import React from 'react';
import { connectRefinementList } from 'react-instantsearch-dom';
import Flex from './Flex';
import Checkbox from './form/Checkbox';
import Text from './Text';
const AlgoliaCheckboxBooleanRefinement = /*#__PURE__*/React.memo(_ref => {
  let {
    attribute,
    count = true,
    currentRefinement,
    fontSize = 1,
    items,
    label,
    refine
  } = _ref;
  const item = items.find(i => i.label === 'true') || {
    value: 'true',
    count: 0,
    isRefined: Array.isArray(currentRefinement) && currentRefinement.includes('true')
  };
  const handleChange = _ref2 => {
    let {
      target
    } = _ref2;
    target.checked ? refine('true') : refine('');
  };
  return /*#__PURE__*/React.createElement(Flex, {
    as: "label",
    sx: {
      alignItems: 'center',
      fontSize
    }
  }, /*#__PURE__*/React.createElement(Checkbox, {
    name: attribute,
    onChange: handleChange,
    value: 'true',
    checked: item.isRefined
  }), /*#__PURE__*/React.createElement(Text, {
    sx: {
      '&:hover': {
        color: 'secondary',
        textDecoration: 'underline'
      }
    }
  }, label), count && /*#__PURE__*/React.createElement(Text, {
    ml: 1,
    sx: {
      bg: 'gray.4',
      color: 'black',
      borderRadius: 'corner',
      px: '6px',
      ml: '6px',
      fontSize: '.9em',
      lineHeight: 1.2
    }
  }, item.count));
});
AlgoliaCheckboxBooleanRefinement.propTypes = {};
AlgoliaCheckboxBooleanRefinement.displayName = 'AlgoliaCheckboxBooleanRefinement';
export default connectRefinementList(AlgoliaCheckboxBooleanRefinement);